<div class="container">
  <div class="row">
    <div class="col-md-4"></div>
    <div class="col-md-4 bg-white">
      <div class="container">
        <div class="row justify-content-end pb-2">
          <div class="col-md-12 mt-3 headerMobileRow align-self-center">
            <div class="row">
              <div class="col-md-5 col-12 businessLogo align-self-center">
                <img
                  *ngIf="companyData"
                  style="width: 140px"
                  src="{{ companyData.LogoURL }}"
                  class="img-fluid"
                  loading="lazy"
                />
              </div>
              <div class="col-md-7 col-12 businessInfo align-self-center b">
                <h3 class="font500 font26 blackColor mb-0">
                  {{ companyData.BusinessTitle }}
                </h3>
                <p class="mb-0 font16 customPurple mt-2">
                  <i class="fa-solid fa-location-dot pr-2"></i>
                  <span *ngIf="companyData.UnitNo">
                    {{ companyData.UnitNo }}
                  </span>
                  <span *ngIf="companyData['FloorAndTower']">
                    , {{ companyData["FloorAndTower"] }}
                  </span>
                  <span *ngIf="companyData['BuildingOrSociety']">
                    , {{ companyData["BuildingOrSociety"] }}
                  </span>
                  <span *ngIf="companyData['LocalityName']">
                    , {{ companyData["LocalityName"] }}
                  </span>
                  <span *ngIf="companyData['CityName']">
                    , {{ companyData["CityName"] }}
                  </span>
                </p>
                <p class="mb-0 font16 customPurple mt-2">
                  <i class="fa-solid fa-phone pr-2"></i
                  >{{ companyData.MobileCountryCode }}-{{
                    companyData.MOBILENUMBER
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-12 border-bottom border-top">
            <div class="row font500 font16">
              <div class="col-md-4">
                <p class="mb-0 pt-2 pb-2">
                  Order No:
                  <span class="customPurple float-right"
                    >#{{ companyData?.OrderNumber }}</span
                  >
                </p>
              </div>
              <div class="col-md-4 border-left border-right">
                <p class="mb-0 pt-2 pb-2">
                  Order Time:
                  <span class="customPurple float-right">{{
                    companyData?.OrderTime | date : "dd-MM-yyyy, hh:mm a"
                  }}</span>
                </p>
              </div>
              <div class="col-md-4">
                <p class="mb-0 pt-2 pb-2">
                  Order Details:
                  <span class="customPurple float-right">
                    <a
                      href="https://manageorder.instaciti.com/{{
                        paramData?.businessslug
                      }}/{{ paramData?.section }}"
                      target="_blank"
                    >
                      Click Here
                    </a>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12" *ngIf="!feedbackSubmit">
          <p class="font18 text-center font500 customPurple">
            CUSTOMER FEEDBACK FORM
          </p>
        </div>
      </div>
      <div class="container">
        <div class="row" *ngIf="!feedbackSubmit">
          <div class="col-md-12">
            <div class="userImage mt-3"></div>

            <div class="modal-rating-background pt-2">
              <div class="col-md-12 text-center">
                <span><b>How Was Your Experience ?</b></span>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col pr-0">
                    <fieldset class="rating">
                      <input
                        type="radio"
                        id="star5"
                        name="rating"
                        value="5.0"
                        (click)="rating = '5.0'"
                      /><label
                        class="full"
                        for="star5"
                        title="Awesome - 5 stars"
                      ></label>

                      <input
                        type="radio"
                        id="star4"
                        name="rating"
                        value="4.0"
                        (click)="rating = '4.0'"
                      /><label
                        class="full"
                        for="star4"
                        title="Pretty good - 4 stars"
                      ></label>

                      <input
                        type="radio"
                        id="star3"
                        name="rating"
                        value="3.0"
                        (click)="rating = '3.0'"
                      /><label
                        class="full"
                        for="star3"
                        title="Meh - 3 stars"
                      ></label>

                      <input
                        type="radio"
                        id="star2"
                        name="rating"
                        value="2.0"
                        (click)="rating = '2.0'"
                      /><label
                        class="full"
                        for="star2"
                        title="Kinda bad - 2 stars"
                      ></label>

                      <input
                        type="radio"
                        id="star1"
                        name="rating"
                        value="1.0"
                        (click)="rating = '1.0'"
                      /><label
                        class="full"
                        for="star1"
                        title="Sucks big time - 1 star"
                      ></label>

                      <input
                        type="radio"
                        class="reset-option"
                        name="rating"
                        value="reset"
                      />
                    </fieldset>
                  </div>
                  <div class="col-4 rating-output mt-2">
                    <span
                      ><b class="myratings">{{ rating }}</b></span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div
                class="col-md-12 custom-text-color pt-3"
                *ngIf="checkboxList"
              >
                <div
                  class="col-md-12 custom-text-color pt-3"
                  *ngIf="checkboxList"
                >
                  <div
                    class="custom-control custom-checkbox"
                    *ngFor="let cbox of checkboxList; let i = index"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="{{ cbox.RatingParamID }}"
                      (click)="toggleCheckbox(i)"
                      [(ngModel)]="cbox.checked"
                    />
                    <label
                      class="custom-control-label checkbox-label"
                      for="{{ cbox.RatingParamID }}"
                    >
                      <p class="m-0">{{ cbox.RatingParameter }}</p>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="pt-3 pb-3">
              <b>Write your review</b>
            </div>

            <div class="form-group">
              <p class="wizardFormHeading mb-1"></p>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                [(ngModel)]="comments"
                placeholder="Comments"
              ></textarea>
            </div>

            <div class="pt-3">
              <b>Add Photos</b>
            </div>

            <div class="col-2 p-0 pt-2 mb-2">
              <span class="btn btn-lg prepend-background fileinput-button">
                <span><i class="fa fa-2x fas fa-camera p-2"></i></span>
                <input
                  type="file"
                  name="files[]"
                  id="files"
                  multiple
                  (change)="previewImages($event)"
                /><br />
              </span>
              <div id="image_preview">
                <div class="row"></div>
              </div>
            </div>

            <div class="clearfix"></div>

            <div class="pt-3">
              <b>Mention Staff by name</b>
            </div>

            <div class="mt-3">
              <div class="staffImages">
                <p>
                  <a
                    class="btn btn-danger submitButton"
                    data-toggle="collapse"
                    href="#collapseExample"
                    role="button"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                  >
                    Show Staff <i class="fa-solid fa-angle-down pl-3"></i>
                  </a>
                </p>
                <div class="collapse" id="collapseExample">
                  <div class="card card-body">
                    <div class="staffList">
                      <div class="row scrollOffer" *ngIf="staffList.length">
                        <div
                          *ngFor="let staff of staffList"
                          [ngClass]="{ selected: staff.isSelected }"
                          class="col-6 col-md-3 col-lg-2 manualOffer mt-3 mb-3 d-flex align-items-stretch p-1"
                        >
                          <div class="card w-100 borderRadius10">
                            <div
                              class="card-body text-center"
                              (click)="deleteMe(staff.id)"
                            >
                              <img
                                src="{{ staff.PhotoURL }}"
                                *ngIf="staff.PhotoURL"
                                class="img-fluid rounded-circle"
                                alt="specialist"
                                id="s"
                              />
                              <p class="blackText mb-0 mt-3">
                                {{ staff.FullName }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12 customerDetails mt-4">
              <form [formGroup]="FeedbackForm" onsubmit="false" class="frmwzrd">
                <div class="instaWizard">
                  <div class="row mt-2">
                    <div class="col-md-12 p-0">
                      <div class="row">
                        <div class="col-12 form-group">
                          <p class="wizardFormHeading mb-1 pt-3 mb-1">
                            Your Name
                          </p>
                          <input
                            formControlName="Name"
                            class="form-control"
                            type="email"
                            class="form-control formHeight"
                            id="inputName"
                            placeholder="Your full name"
                          />
                        </div>
                        <div class="col-12 form-group">
                          <p class="wizardFormHeading mb-1 pt-3 mb-1">
                            Your Email
                          </p>
                          <input
                            formControlName="Email"
                            class="form-control"
                            type="email"
                            class="form-control formHeight"
                            id="inputEmail"
                            placeholder="Your email address"
                          />
                        </div>
                        <div class="col-12 form-group">
                          <p class="wizardFormHeading mb-1 pt-3 mb-1">
                            Your Phone
                          </p>
                          <input
                            formControlName="Phone"
                            class="form-control"
                            type="number"
                            class="form-control formHeight"
                            id="inputPhone"
                            placeholder="Your mobile number"
                          />
                        </div>
                      </div>

                      <button
                        (click)="onSubmit()"
                        type="submit"
                        class="btn btn-block submitButton mt-3"
                      >
                        <i class="fas fa-check-circle mr-3"></i>

                        <span class="comment-content"
                          >Submit your feedback</span
                        >
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="container" *ngIf="feedbackSubmit">
        <div class="row">
          <div class="col-md-12 text-center acknowledgmentMessage">
            <img
              src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/icon/check-mark.png"
              alt=""
            />
            <h2 class="text-success">
              Thank you, Your Feedback has been submitted.
            </h2>
          </div>
        </div>
      </div>
      <div class="footerSection">
        <div class="footerText text-center border-top pt-3 mt-3 pb-1">
          <p>
            Copyright 2024 | Powered by
            <span
              ><a href="https://www.instaciti.com"
                ><img
                  src="https://instaciti.com/assets/img/logo.png"
                  style="width: 120px" /></a
            ></span>
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-4"></div>
  </div>
</div>
